import { z } from 'zod';

const MIN_PASSWORD_LENGTH = 8;
export const MAX_FILE_SIZE = 500000;
const ACCEPTED_IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];

export const emailSchema = z.string().email('Invalid email');

export const passSchema = z.string();

export const passwordSchema = z
    .string()
    .min(MIN_PASSWORD_LENGTH, `Password must be more than ${MIN_PASSWORD_LENGTH} characters`);

export const nameSchema = z.string();

export const companyNameSchema = z.string();

export const phoneSchema = z.string();

export const websiteSchema = z.string();

export const answerSchema = z.string();

export const languageSchema = z.number();

export const avatarSchema = z.object({
    image: z
        .any()
        .refine((file) => file?.size <= MAX_FILE_SIZE, `Max image size is 5MB`)
        .refine(
            (file) => ACCEPTED_IMAGE_TYPES.includes(file?.type),
            'Only .jpg, .jpeg, .png and .webp formats are supported.'
        )
        .or(z.string()),
});
